

(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-cerus-sticky-atc]');
    if (!bar) return;

    var mainAtc = document.querySelector('[data-cerus-atc]');
    var mainAtcRow = document.querySelector('.cerus-atc-row');
    if (!mainAtcRow || !mainAtc) return;

    var titleEl   = bar.querySelector('[data-cerus-sticky-title]');
    var variantEl = bar.querySelector('[data-cerus-sticky-variant]');
    var priceEl   = bar.querySelector('[data-cerus-sticky-price]');
    var imageEl   = bar.querySelector('[data-cerus-sticky-image]');
    var btn       = bar.querySelector('[data-cerus-sticky-atc-btn]');
    var labelEl   = bar.querySelector('[data-cerus-sticky-atc-label]');
    var linkEl    = bar.querySelector('[data-cerus-sticky-link]');
    var optionSel = bar.querySelector('[data-cerus-sticky-option-select]');
    var optionSwatchImg = bar.querySelector('[data-cerus-sticky-option-swatch] img');



    function sync(eventDetail) {
      var titleNode = document.querySelector('[data-cerus-title]');
      var priceNode = document.querySelector('[data-cerus-price]');
      var atcLabelNode = mainAtc.querySelector('[data-cerus-atc-label]');

      if (titleEl && titleNode) titleEl.textContent = titleNode.textContent.trim();
      if (priceEl && priceNode) priceEl.textContent = priceNode.textContent.trim();
      if (labelEl && atcLabelNode) labelEl.textContent = atcLabelNode.textContent.trim();
      if (btn) btn.disabled = mainAtc.disabled;


      var newImg = '';
      if (eventDetail && eventDetail.imageSrc) newImg = eventDetail.imageSrc;
      if (!newImg) {
        var activeSlide = document.querySelector('.cerus-gallery__slide.is-active');
        var activeMedia = activeSlide && activeSlide.querySelector('img');
        if (activeMedia) newImg = activeMedia.currentSrc || activeMedia.src;
      }
      if (imageEl && newImg) imageEl.src = newImg;

      if (variantEl) {
        var selected = [];
        document.querySelectorAll('input[name^="option-"]:checked').forEach(function (input) {
          selected.push(input.value);
        });
        if (selected.length) variantEl.textContent = selected.join(' / ');
      }

      var accent = mainAtc.dataset.cerusAtcColor || mainAtc.style.getPropertyValue('--cerus-cta-accent-bg');
      if (accent && btn) {
        btn.style.setProperty('--cerus-cta-accent-bg', accent);
        btn.style.setProperty('--cerus-cta-accent-border', accent);
        btn.style.setProperty('--cerus-cta-accent-bg-hover', accent);
        btn.style.setProperty('--cerus-cta-accent-border-hover', accent);
      }

      if (optionSel) {
        var pos = optionSel.dataset.optionPosition;
        var checked = document.querySelector('input[name="option-' + pos + '"]:checked');
        if (checked && optionSel.value !== checked.value) optionSel.value = checked.value;
      }


      if (optionSwatchImg) {
        var swatchSrc = (eventDetail && eventDetail.swatchImage) || '';
        if (!swatchSrc) {
          var activePill = document.querySelector('.cerus-flavor.is-active img, .cerus-option__pill.is-active img');
          if (activePill && activePill.src) swatchSrc = activePill.src;
        }
        if (swatchSrc) optionSwatchImg.src = swatchSrc;
      }
    }

    sync();
    document.addEventListener('cerus:variant-change', function (e) { sync(e && e.detail); });


    if (optionSel) {
      optionSel.addEventListener('change', function () {
        var pos = optionSel.dataset.optionPosition;
        var target = document.querySelector('input[name="option-' + pos + '"][value="' + CSS.escape(optionSel.value) + '"]');
        if (target) {
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    if (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        mainAtc.click();
      });
    }

    if (linkEl) {
      linkEl.addEventListener('click', function (e) {
        e.preventDefault();
        var gallery = document.querySelector('[data-cerus-gallery]');
        if (gallery) gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    function setVisible(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.style.paddingBottom = visible ? bar.offsetHeight + 'px' : '';
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];

        setVisible(!entry.isIntersecting);
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
      io.observe(mainAtcRow);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
